module.exports = __webpack_public_path__ + "img/part3-5.48116029.png";